import { effects } from 'redux-saga'
import { push as pushPath } from 'react-router-redux'

export default function* initSaga(FINISH_LOADING) {
  yield effects.take(FINISH_LOADING)

  const state = yield effects.select()
  const currentPath = state.router.locationBeforeTransitions.pathname

  if (currentPath.startsWith('/login')) {
    return
  }

  const hmac = state.authentication.get('hmac')
  if (hmac && hmac.get('expires').isAfter()) {
    return
  }

  const path = currentPath.startsWith('/login') || currentPath === '/'
    ? '/login'
    : `/login?returnTo=${currentPath}`

  yield effects.put.resolve(pushPath(path))
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/authentication/init.js